import React, { useEffect, useState } from "react";
import { Navigation, MapPin } from "lucide-react";
import { FaRegCircleUser } from "react-icons/fa6";
import { Link } from "react-router-dom";
import RestaurantFeed from "./RestaurantFeed";
import logo from "../assetsWeb/images/logoNew.png";
import footerlogo from "../assetsWeb/images/logo-color.png";
import googlee from "../assetsWeb/images/Google_Play_Store_badge_EN.png";
import applee from "../assetsWeb/images/Download_on_the_App_Store_RGB_blk.png";
import SearchedByMap from "../components/SearchedByMap";
import { setAddress } from "../actions/orderActions";
import { useDispatch, useSelector } from "react-redux";

// import { useDispatch, useSelector } from "react-redux";
// import { getAllItems, setItemData } from "../actions/itemActions";
// import { userLogout } from "../actions/authActions";
// import { getAllStores } from "../actions/storeActions";

const HomeAllFoods = () => {
  const { deliverAddress } = useSelector((state) => state.orders);
  const [values, setValues] = useState({
    address: "",
  });
  const dispatch = useDispatch();

  const addressSave = (address) => {
    dispatch(setAddress(address));
  };
  useEffect(() => {
    if (values?.address) {
      addressSave(values?.address);
    }
  }, [values?.address]);
  useEffect(() => {
    setValues({
      ...values,
      address: deliverAddress,
    });
  }, [deliverAddress]);

  return (
    <>
      <div className="app-container">
        <header className="header02">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <a className="" href="/">
                <div className="logo">
                  <span className="logo-text">
                    {" "}
                    <img src={logo} alt="" style={{ width: "52%" }} />
                  </span>
                  <span className="logo-dot"></span>
                </div>
              </a>

              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              <div
                className="collapse navbar-collapse justify-content-end"
                id="navbarSupportedContent"
              >
                <Link
                  to="/login"
                  className="button-21"
                  role="button"
                  style={{
                    marginRight: "45px",
                    color: "#ffffff",
                    backgroundColor: "#28B8EC",
                  }}
                >
                  <span className="icon-user">
                    <FaRegCircleUser />
                  </span>
                  &nbsp;Login
                </Link>
              </div>
            </div>
          </nav>
        </header>
        <div className="location-bar">
          <div className="container-fluid">
            <div
              className="row align-items-center"
              style={{ justifyContent: "center" }}
            >
              <div className="col-12 col-md-5">
                <div className="location-info">
                  <div className="location-icon">
                    <MapPin size={24} color="#f44336" />
                  </div>
                  <div className="location-text">
                    <p>
                      These stores are in central area, add your address to see
                      the ones delivering to you.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-5">
                <SearchedByMap
                  values={values}
                  setValues={setValues}
                  searchAddress={values?.address?.address}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid main-content">
          <RestaurantFeed />
        </div>

        <div className="">
          <div class="curve-wrapper" style={{ marginBottom: "-1px" }}>
            <svg viewBox="0 0 1440 100" class="top-curve">
              <path
                d="M0,100 C480,0 960,0 1440,100 L1440,100 L0,100 Z"
                fill="#000"
              />
            </svg>
          </div>
          {/* <div className="footer-arch-top"></div> */}
          <footer>
            <h3
              style={{
                display: "flex",
              }}
            >
              <a className="navbar-brand" href="#">
                <img
                  src={footerlogo}
                  alt="Logo"
                  id="logsedf"
                  style={{ width: "52%" }}
                />
              </a>
            </h3>
            <div className="footer-container">
              <div className="footer-column">
                {/* <h3>Let’s do it together</h3> */}
                <ul>
                  <li>
                    <a
                      href="#"
                      style={{ fontSize: "large", fontWeight: "bold" }}
                    >
                      Let’s do it together
                    </a>
                  </li>
                  <li>
                    <a href="#">Career</a>
                  </li>
                  <li>
                    <a href="#">Partner</a>
                  </li>
                  <li>
                    <a href="#">Couriers</a>
                  </li>
                  <li>
                    <a href="#">Business</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <ul>
                  <li>
                    <a
                      href="#"
                      style={{ fontSize: "large", fontWeight: "bold" }}
                    >
                      Link of Interest
                    </a>
                  </li>
                  <li>
                    <a href="#">About Us</a>
                  </li>
                  <li>
                    <a href="#">FAQs</a>
                  </li>
                  <li>
                    <a href="#">Drovi Prime</a>
                  </li>
                  <li>
                    <a href="#">Blog</a>
                  </li>
                  <li>
                    <a href="#">Contact Us</a>
                  </li>
                  <li>
                    <a href="#">Security</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <ul>
                  <li>
                    <a
                      href="#"
                      style={{ fontSize: "large", fontWeight: "bold" }}
                    >
                      Follow us
                    </a>
                  </li>
                  <li>
                    <a href="#">Facebook</a>
                  </li>
                  <li>
                    <a href="#">Twitter</a>
                  </li>
                  <li>
                    <a href="#">Instagram</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <div className="app-icons">
                  <ul>
                    <li>
                      <a href="#">
                        <img src={googlee} alt="Google Play" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <img src={applee} alt="App Store" />
                      </a>
                    </li>
                    <li>
                      <a href="#">Terms & Conditions</a>
                    </li>
                    <li>
                      <a href="#">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="#">Cookies Policy</a>
                    </li>
                    <li>
                      <a href="#">Compilance</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <p>All Rights Reserved. Iconictek Company © 2024</p>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};
export default HomeAllFoods;
